export default "__VITE_PUBLIC_ASSET__262c9b43__"